/*
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import complaintService from '../../services/complaintService';

const ComplaintForm = () => {
  const [form, setForm] = useState({
    title: '',
    description: '',
    category: 'littering',
    priority: 'medium',
    address: '',
    location: { latitude: '', longitude: '' },
  });
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('location.')) {
      const field = name.split('.')[1];
      setForm((prev) => ({
        ...prev,
        location: { ...prev.location, [field]: value },
      }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const onImageChange = (e) => {
    setImages(Array.from(e.target.files || []));
  };

  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      toast.error('Geolocation not supported');
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setForm((prev) => ({
          ...prev,
          location: {
            latitude: String(pos.coords.latitude),
            longitude: String(pos.coords.longitude),
          },
        }));
        toast.success('Location captured');
      },
      () => toast.error('Unable to get location')
    );
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (
      !form.location.latitude ||
      !form.location.longitude ||
      !form.address
    ) {
      toast.error('Location and address are required');
      return;
    }
    setLoading(true);
    try {
      await complaintService.createComplaint({
        ...form,
        images,
      });
      toast.success('Complaint submitted');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to submit complaint');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto mt-6 bg-white shadow rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4">Submit New Complaint</h2>
      <form onSubmit={onSubmit} className="space-y-4">
        <input
          name="title"
          placeholder="Title"
          className="w-full border px-3 py-2 rounded-md"
          value={form.title}
          onChange={onChange}
          required
        />
        <textarea
          name="description"
          placeholder="Description"
          rows={4}
          className="w-full border px-3 py-2 rounded-md"
          value={form.description}
          onChange={onChange}
          required
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm mb-1">Category</label>
            <select
              name="category"
              value={form.category}
              onChange={onChange}
              className="w-full border px-3 py-2 rounded-md"
            >
              <option value="littering">Littering</option>
              <option value="illegal_dumping">Illegal Dumping</option>
              <option value="overflowing_bins">Overflowing Bins</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div>
            <label className="block text-sm mb-1">Priority</label>
            <select
              name="priority"
              value={form.priority}
              onChange={onChange}
              className="w-full border px-3 py-2 rounded-md"
            >
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
            </select>
          </div>
        </div>

        <input
          name="address"
          placeholder="Address"
          className="w-full border px-3 py-2 rounded-md"
          value={form.address}
          onChange={onChange}
          required
        />

        <div>
          <label className="block text-sm mb-1">Location (Lat, Long)</label>
          <div className="grid grid-cols-2 gap-4">
            <input
              name="location.latitude"
              placeholder="Latitude"
              className="w-full border px-3 py-2 rounded-md"
              value={form.location.latitude}
              onChange={onChange}
              required
            />
            <input
              name="location.longitude"
              placeholder="Longitude"
              className="w-full border px-3 py-2 rounded-md"
              value={form.location.longitude}
              onChange={onChange}
              required
            />
          </div>
          <button
            type="button"
            onClick={getCurrentLocation}
            className="mt-2 text-sm text-indigo-600"
          >
            Use current location
          </button>
        </div>

        <div>
          <label className="block text-sm mb-1">Before Images</label>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={onImageChange}
            className="w-full border px-3 py-2 rounded-md"
          />
          <p className="text-xs text-gray-500 mt-1">
            You can upload up to 5 images.
          </p>
        </div>

        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={() => navigate('/dashboard')}
            className="px-4 py-2 text-sm border rounded-md"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-4 py-2 text-sm bg-indigo-600 text-white rounded-md disabled:opacity-50"
          >
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ComplaintForm;
*/

`
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import complaintService from '../../services/complaintService';

const ComplaintForm = () => {
  const [form, setForm] = useState({
    title: '',
    description: '',
    category: 'littering',
    priority: 'medium',
    address: '',
    location: { latitude: '', longitude: '' },
  });
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('location.')) {
      const field = name.split('.')[1];
      setForm((prev) => ({
        ...prev,
        location: { ...prev.location, [field]: value },
      }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const onImageChange = (e) => {
    setImages(Array.from(e.target.files || []));
  };

  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      toast.error('Geolocation not supported in this browser');
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setForm((prev) => ({
          ...prev,
          location: {
            latitude: String(pos.coords.latitude),
            longitude: String(pos.coords.longitude),
          },
        }));
        toast.success('Location captured');
      },
      () => toast.error('Unable to get location')
    );
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (
      !form.location.latitude ||
      !form.location.longitude ||
      !form.address
    ) {
      toast.error('Address and location are required');
      return;
    }
    setLoading(true);
    try {
      await complaintService.createComplaint({
        ...form,
        images,
      });
      toast.success('Complaint submitted successfully');
      navigate('/dashboard');
    } catch (err) {
      toast.error(
        err.response?.data?.message || 'Failed to submit complaint'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-6 px-4">
      <div className="bg-white shadow-md rounded-2xl p-5 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">
              Report a Garbage Issue
            </h2>
            <p className="text-xs text-gray-500 mt-1">
              Provide details so authorities can quickly locate and fix the
              problem.
            </p>
          </div>
          <div className="flex items-center gap-2 text-[11px] text-gray-500 bg-indigo-50 border border-indigo-100 px-3 py-2 rounded-xl">
            <span className="text-lg">ℹ️</span>
            <span>
              Accurate location & clear photos help faster resolution.
            </span>
          </div>
        </div>

        <form onSubmit={onSubmit} className="space-y-5">
          {/* Basic info */}
          <section className="space-y-3 border-b pb-4">
            <h3 className="text-sm font-semibold text-gray-800">
              1. Basic Details
            </h3>
            <input
              name="title"
              placeholder="Short title (e.g., Overflowing garbage near park gate)"
              className="w-full border px-3 py-2 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
              value={form.title}
              onChange={onChange}
              required
            />
            <textarea
              name="description"
              placeholder="Describe the issue, how long it has been there, and any other helpful details."
              rows={4}
              className="w-full border px-3 py-2 rounded-md text-sm resize-y focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
              value={form.description}
              onChange={onChange}
              required
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Category
                </label>
                <select
                  name="category"
                  value={form.category}
                  onChange={onChange}
                  className="w-full border px-3 py-2 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                >
                  <option value="littering">Littering</option>
                  <option value="illegal_dumping">Illegal Dumping</option>
                  <option value="overflowing_bins">
                    Overflowing Dustbins
                  </option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Priority
                </label>
                <select
                  name="priority"
                  value={form.priority}
                  onChange={onChange}
                  className="w-full border px-3 py-2 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium (default)</option>
                  <option value="high">High (health hazard)</option>
                </select>
              </div>
            </div>
          </section>

          {/* Location */}
          <section className="space-y-3 border-b pb-4">
            <h3 className="text-sm font-semibold text-gray-800">
              2. Location
            </h3>
            <input
              name="address"
              placeholder="Address or landmark (e.g., Near Bus Stop, XYZ Street)"
              className="w-full border px-3 py-2 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
              value={form.address}
              onChange={onChange}
              required
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Latitude
                </label>
                <input
                  name="location.latitude"
                  placeholder="Latitude"
                  className="w-full border px-3 py-2 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                  value={form.location.latitude}
                  onChange={onChange}
                  required
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Longitude
                </label>
                <input
                  name="location.longitude"
                  placeholder="Longitude"
                  className="w-full border px-3 py-2 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                  value={form.location.longitude}
                  onChange={onChange}
                  required
                />
              </div>
            </div>
            <button
              type="button"
              onClick={getCurrentLocation}
              className="inline-flex items-center text-xs text-indigo-600 hover:text-indigo-700 mt-1"
            >
              📍 Use my current location
            </button>
          </section>

          {/* Images */}
          <section className="space-y-3">
            <h3 className="text-sm font-semibold text-gray-800">
              3. Attach Photos (Before Cleaning)
            </h3>
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={onImageChange}
              className="w-full border px-3 py-2 rounded-md text-sm bg-gray-50"
            />
            <p className="text-[11px] text-gray-500">
              Upload up to 5 clear photos showing the garbage from different
              angles. This helps the team understand the situation quickly.
            </p>
          </section>

          <div className="pt-3 flex justify-between items-center">
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              className="px-4 py-2 text-xs sm:text-sm border rounded-full text-gray-600 hover:bg-gray-50"
            >
              Cancel &amp; go back
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-5 py-2 text-xs sm:text-sm rounded-full bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-60 shadow-sm"
            >
              {loading ? 'Submitting...' : 'Submit Complaint'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ComplaintForm;
`

// frontend/src/components/complaint/ComplaintForm.js
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import complaintService from '../../services/complaintService';

const ComplaintForm = () => {
  const [form, setForm] = useState({
    title: '',
    description: '',
    category: 'littering',
    priority: 'medium',
    address: '',
    location: { latitude: '', longitude: '' },
  });
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onChange = (e) => {
    const { name, value } = e.target;
    // handle nested location fields
    if (name.startsWith('location.')) {
      const field = name.split('.')[1];
      setForm((prev) => ({
        ...prev,
        location: { ...prev.location, [field]: value },
      }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const onImageChange = (e) => {
    setImages(Array.from(e.target.files || []));
  };

  // UPDATED: better error messages + debug logging
  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      toast.error('Geolocation is not supported in this browser');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;

        // Optional: sanity check ranges (Mongo 2dsphere needs valid coords)
        if (
          latitude < -90 ||
          latitude > 90 ||
          longitude < -180 ||
          longitude > 180
        ) {
          toast.error('Received invalid coordinates from device');
          console.error('Invalid coords from geolocation:', {
            latitude,
            longitude,
          });
          return;
        }

        setForm((prev) => ({
          ...prev,
          location: {
            latitude: String(latitude),
            longitude: String(longitude),
          },
        }));

        console.log('Location captured:', latitude, longitude);
        toast.success('Location captured from device');
      },
      (error) => {
        console.error('Geolocation error:', error);

        if (error.code === error.PERMISSION_DENIED) {
          toast.error(
            'Location permission denied. Please allow it in browser settings and try again.'
          );
        } else if (error.code === error.POSITION_UNAVAILABLE) {
          toast.error('Location information is unavailable.');
        } else if (error.code === error.TIMEOUT) {
          toast.error('Location request timed out. Please try again.');
        } else {
          toast.error('Unable to get location. Please enter manually.');
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    // basic validation
    if (
      !form.location.latitude ||
      !form.location.longitude ||
      !form.address
    ) {
      toast.error('Address and location (latitude & longitude) are required');
      return;
    }

    const lat = parseFloat(form.location.latitude);
    const lng = parseFloat(form.location.longitude);

    if (
      Number.isNaN(lat) ||
      Number.isNaN(lng) ||
      lat < -90 ||
      lat > 90 ||
      lng < -180 ||
      lng > 180
    ) {
      toast.error(
        'Please enter valid coordinates. Latitude: -90 to 90, Longitude: -180 to 180.'
      );
      return;
    }

    setLoading(true);
    try {
      await complaintService.createComplaint({
        ...form,
        images,
      });
      toast.success('Complaint submitted successfully');
      navigate('/dashboard');
    } catch (err) {
      console.error('Create complaint error:', err);
      toast.error(
        err.response?.data?.message || 'Failed to submit complaint'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-6 px-4">
      <div className="bg-white shadow-md rounded-2xl p-5 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-4">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">
              Report a Garbage Issue
            </h2>
            <p className="text-xs text-gray-500 mt-1">
              Provide details so authorities can quickly locate and fix the
              problem.
            </p>
          </div>
          <div className="flex items-center gap-2 text-[11px] text-gray-500 bg-indigo-50 border border-indigo-100 px-3 py-2 rounded-xl">
            <span className="text-lg">ℹ️</span>
            <span>
              Accurate location &amp; clear photos help faster resolution.
            </span>
          </div>
        </div>

        <form onSubmit={onSubmit} className="space-y-5">
          {/* Basic info */}
          <section className="space-y-3 border-b pb-4">
            <h3 className="text-sm font-semibold text-gray-800">
              1. Basic Details
            </h3>
            <input
              name="title"
              placeholder="Short title (e.g., Overflowing garbage near park gate)"
              className="w-full border px-3 py-2 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
              value={form.title}
              onChange={onChange}
              required
            />
            <textarea
              name="description"
              placeholder="Describe the issue, how long it has been there, and any other helpful details."
              rows={4}
              className="w-full border px-3 py-2 rounded-md text-sm resize-y focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
              value={form.description}
              onChange={onChange}
              required
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Category
                </label>
                <select
                  name="category"
                  value={form.category}
                  onChange={onChange}
                  className="w-full border px-3 py-2 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                >
                  <option value="littering">Littering</option>
                  <option value="illegal_dumping">Illegal Dumping</option>
                  <option value="overflowing_bins">
                    Overflowing Dustbins
                  </option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Priority
                </label>
                <select
                  name="priority"
                  value={form.priority}
                  onChange={onChange}
                  className="w-full border px-3 py-2 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium (default)</option>
                  <option value="high">High (health hazard)</option>
                </select>
              </div>
            </div>
          </section>

          {/* Location */}
          <section className="space-y-3 border-b pb-4">
            <h3 className="text-sm font-semibold text-gray-800">
              2. Location
            </h3>
            <input
              name="address"
              placeholder="Address or landmark (e.g., Near Bus Stop, XYZ Street)"
              className="w-full border px-3 py-2 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
              value={form.address}
              onChange={onChange}
              required
            />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Latitude
                </label>
                <input
                  name="location.latitude"
                  placeholder="Latitude"
                  className="w-full border px-3 py-2 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                  value={form.location.latitude}
                  onChange={onChange}
                  required
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Longitude
                </label>
                <input
                  name="location.longitude"
                  placeholder="Longitude"
                  className="w-full border px-3 py-2 rounded-md text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
                  value={form.location.longitude}
                  onChange={onChange}
                  required
                />
              </div>
            </div>
            <button
              type="button"
              onClick={getCurrentLocation}
              className="inline-flex items-center text-xs text-indigo-600 hover:text-indigo-700 mt-1"
            >
              📍 Use my current location
            </button>
          </section>

          {/* Images */}
          <section className="space-y-3">
            <h3 className="text-sm font-semibold text-gray-800">
              3. Attach Photos (Before Cleaning)
            </h3>
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={onImageChange}
              className="w-full border px-3 py-2 rounded-md text-sm bg-gray-50"
            />
            <p className="text-[11px] text-gray-500">
              Upload up to 5 clear photos showing the garbage from different
              angles. This helps the team understand the situation quickly.
            </p>
          </section>

          <div className="pt-3 flex justify-between items-center">
            <button
              type="button"
              onClick={() => navigate('/dashboard')}
              className="px-4 py-2 text-xs sm:text-sm border rounded-full text-gray-600 hover:bg-gray-50"
            >
              Cancel &amp; go back
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-5 py-2 text-xs sm:text-sm rounded-full bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-60 shadow-sm"
            >
              {loading ? 'Submitting...' : 'Submit Complaint'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ComplaintForm;
